/*!
 *
 *	nav-active.js
 *
 */

$.NavActive = function( _this, opt ){
	this.$wrap = $(_this);
	this.$a = this.$wrap.find('a');
	this.settings = {
		activeClass : 'active',
		abs: false,
		not: false
	};
	this.settings = $.extend( this.settings, opt );
	this.sort();
};

$.NavActive.prototype = {
	sort : function(){
		var self = this;
		var _href;
		var _globalURL = this.locate('path') + this.locate('search');
		if( !self.settings.not ){
			self.settings.not = '#XYZ';
		};
		this.$a.not( self.settings.not ).each(function(){
			_href = $(this).attr('href').replace( self.locate('location') , '' );
			if( self.settings.abs ){
				if( _globalURL ==  _href ){
					$(this).addClass( self.settings.activeClass );
					if( $(this).is('.local-box a') ){
						var _head = $(this).closest('.local-box').children('.local-box__head');
						$.localMenu.toggle(_head);
					};
				};
			}else{
				if( _globalURL.search( _href ) == 0 ){
					$(this).addClass( self.settings.activeClass );
				};
			};
		});
	},
	locate : function( _call ){
		if( !_call ) return false;
		switch( _call ){
			case 'path' :
				return this.url.path;
			case 'location' :
				return this.url.protocol + '//' + this.url.domain;
			case 'domain' :
				return this.url.domain;
			case 'protocol' :
				return this.url.protocol;
			case 'search' :
				return this.url.search;
		};
	},
	url : {
		protocol : location.protocol,
		domain : location.hostname,
		path : location.pathname,
		search : location.search
	},
	isImage : false
};

$.fn.navActive = function( options ){
	var opt = options || {};
	return this.each(function(){
		new $.NavActive( this, opt );
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/nav-active.js
// module id = 12
// module chunks = 0